/**
 * Der Prioritaetspunkt (V-03) - in Aufgabenliste und Kalender dieselbe Farbe
 * aus demselben zentralen Token. Die Bedeutung steht immer auch als Text
 * daneben bzw. fuer Screenreader da, nie nur als Farbe.
 */
import { priorityColor, priorityLabel } from '@/domain/priority';
import { cn } from '@/lib/utils/cn';
import type { PriorityKey } from '@/domain/types';

export function PriorityDot({ priority, className, dekorativ = false }: {
  priority: PriorityKey;
  className?: string;
  /** Die Stufe steht schon als Text daneben - dann nichts doppelt vorlesen. */
  dekorativ?: boolean;
}) {
  const label = priorityLabel(priority);
  return (
    <span className={cn('inline-flex shrink-0 items-center', className)} title={dekorativ ? undefined : `Priorität: ${label}`}>
      <span
        data-marks
        style={{ '--punkt': priorityColor(priority) } as React.CSSProperties}
        className="mark-punkt size-2.5 rounded-full"
        aria-hidden="true"
      />
      {!dekorativ && <span className="sr-only">Priorität: {label}</span>}
    </span>
  );
}
